import { combineReducers } from 'redux';

const passThrough = (state = '') => state;

export default combineReducers({
  host: passThrough,
  isApp: passThrough,
});
